import {
    createFilterPill,
    FILTER_PILL_ITEM_STATE_CHECKED,
    FilterPill,
    IFilterPillItem,
} from '@vfde-brix/ws10/filter-pill';
import { StateProps } from '../container/App/interfaces/state';
import { toggleCategory } from '../container/App/slice';
import {
    mapStateToProps,
    selectAvailableCategories,
} from '../container/App/selectors';
import { startAppListening } from '../container/App/listener';
import { useDispatch } from '../store';

/**
 * Mount filter pill component
 */
export default function mountFilterPill (
    containerId: string,
): FilterPill | null {
    const dispatch = useDispatch();
    const container = document.getElementById(containerId);
    const properties = {
        onClick: (id: string) => dispatch(toggleCategory({
            label: id,
        })),
    };

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const filterPills = createFilterPill(container, properties);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectAvailableCategories(currentState) !== selectAvailableCategories(previousState),
        effect: (action, listenerApi) => {
            const state = mapStateToProps(listenerApi.getState());

            const hasNoAvailableCategories = state.availableCategories.length === 0;

            filterPills?.toggleContainer(hasNoAvailableCategories, true);
            filterPills?.update({
                listFilterPillItems: convertApiCategoriesToFilterPillItems(state),
            });
        },
    });

    return filterPills;
}

/**
 * Convert categories from API to filter pill properties
 */
export const convertApiCategoriesToFilterPillItems = (state: StateProps): IFilterPillItem[] => {
    const { availableCategories } = state;

    return availableCategories
        .map(availableCategory => {
            const value = availableCategory.label;
            const isSelected = state.selectedCategories.some(selectedCategory => selectedCategory.label === availableCategory.label);
            const optState = isSelected ? FILTER_PILL_ITEM_STATE_CHECKED : undefined;

            return {
                stdPillLabel: availableCategory.label,
                stdValue: value,
                optState,
            };
        });
};
